<template>
  <main>
    <section class="wrapper align-items-center pb-12 f-column min-win-height">
      <div v-if="model.save.successful && model.save.type === 'SAVE'" class="container-860">
        <div
          class="container-full pl-10 pr-10 pl-2-768 pr-2-768 pr pb-4 gray-border-bottom f-center f-column mb-children-3 font-center">
          <h2 class="font-huge h2-480 mb-3-480">SKVELÉ</h2>

          <strong class="font-center font-medium">
            Odoslanie fotografií prebehlo úspešne!
          </strong>
        </div>

        <div class="mt-4 container-full pl-10 pr-10 pl-2-768 pr-2-768 pb-4 f-center f-column mb-children-3 font-center">
          <p class="font-center">
            Potvrdenie o úspešnom uložení fotografií v našom systéme Vám pošleme na emailovú adresu <br/>
            <b>{{ insurerEmail }}</b>
          </p>
          <p class="font-center">
            Ak nemáte e-mail v Doručenej pošte, skontrolujte si záložky „Reklamy“, „Spam“ alebo iné.
            <a class="font-red font-underline" target="_blank"
               href="https://www.union.sk/nebol-vam-doruceny-e-mail-s-poistkou-a-pouzivate-gmail/">Viac
              info.</a>
          </p>
        </div>

        <rating :model="model"></rating>
      </div>
      <div v-else-if="model.save.successful && model.save.type === 'FORLATER'" class="container-860">
        <div
          class="container-full pl-10 pr-10 pl-2-768 pr-2-768 pr pb-4 gray-border-bottom f-center f-column mb-children-3 font-center">
          <h2 class="font-huge h2-480 mb-3-480">Vaša rozpracovaná samoobhliadka motorového vozidla bola úspešne
            uložená.</h2>
        </div>

        <div class="mt-4 container-full pl-10 pr-10 pl-2-768 pr-2-768 pb-4 f-center f-column mb-children-3 font-center">
          <p class="font-center">
            Na e-mailovú adresu <b>{{ insurerEmail }}</b> sme Vám poslali odkaz, cez ktorý môžete samoobhliadku a
            nahrávanie fotografií do <b>{{ periodTo | formatDate }}</b> dokončiť.
          </p>
          <p>Ďakujeme.</p>
        </div>
      </div>
      <div v-else-if="!model.save.successful && model.save.type === 'FORLATER'" class="container-860">
        <div
          class="container-full pl-10 pr-10 pl-2-768 pr-2-768 pr pb-4 gray-border-bottom f-center f-column mb-children-3 font-center">
          <h2 class="font-huge h2-480 mb-3-480">Uloženie rozpracovaného formulára zlyhalo!</h2>
        </div>

        <div class="mt-4 container-full pl-10 pr-10 pl-2-768 pr-2-768 pb-4 f-center f-column mb-children-3 font-center">
          <p class="font-center">
            Ľutujeme, ale formulár sa nepodarilo uložiť a odoslať na Vami zadanú e-mailovú adresu.
          </p>
          <p>Prosím, skúste proces zopakovať.</p>
        </div>
        <div
          class="width-10 width-9-768 mb-4 f-center mr-children-2 justify-content-between-768 align-items-center-768">
          <button @click="saveForLater" class="button-red continue" v-scroll-to-error>
            <span>Skúsiť znovu</span>
          </button>

        </div>
      </div>
      <div v-else class="container-860">
        <div
          class="container-full pl-10 pr-10 pl-2-768 pr-2-768 pr pb-4 gray-border-bottom f-center f-column mb-children-3 font-center">
          <h2 class="font-huge h2-480 mb-3-480">Odoslanie fotografií zlyhalo!</h2>

          <strong class="font-center font-medium">
            Ľutujeme, fotografie sa nepodarilo odoslať.
          </strong>
        </div>
        <p class="mt-5">
          Ako postupovať ďalej:
        </p>
        <div class="container-full p-5 pr-2-768 pl-2-768 mb-3 mt-3 background-border-color border-radius-1">
          <div class="container-546 f-column ">
            <div class=" f-column mb-children-2 container-full">

              <div>
                <p class="">Pre úspešné dokončenie procesu:</p>
                <ul class="ml-2">
                  <li><p class="">skúste fotografie odoslať znova teraz alebo neskôr,</p></li>
                  <li><p class="">v prípade pretrvávajúceho problému s odoslaním fotografií kontaktujte naše
                    zákaznícke centrum na tel. č. <strong>0850 003 333.</strong></p></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          class="width-10 width-9-768 mb-4 f-center mr-children-2 justify-content-between-768 align-items-center-768">
          <button @click="tryAgain" class="button-red continue">
            <span>Odoslať teraz</span>
          </button>
          <button @click="tryAgainSaveForLater" class="button-red continue" v-scroll-to-error>
            <span>Odoslať neskôr</span>
          </button>

        </div>
        <div class="width-10 width-9-768 mb-4">
          <check-box v-model="saveForLaterGDPR" :errors="errors">Súhlasím so spracovaním mojej e-mailovej adresy
            pracovníkmi Unionu za účelom aktivít súvisiacich s dokončením tejto samoobhliadky.
            <template slot="validations">
              <div class="error" id="FE020">Pre využitie funkcie uložiť na neskôr je potrebné vyplniť súhlas.
              </div>
            </template>
          </check-box>
        </div>

        <rating :model="model"></rating>
      </div>
      <transparent-footer></transparent-footer>
    </section>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ThankYou',
  computed: {
    ...mapGetters({
      model: 'getModel',
      insurerEmail: 'getEmail',
      periodTo: 'getPeriodTo',
      errors: 'getErrors',
    }),
    saveForLaterGDPR: {
      get() {
        return this.$store.state.saveForLaterGDPR;
      },
      set(value) {
        if (!value) {
          this.$store.commit('SET_ERRORS', [...this.errors, 'FE020']);
        } else {
          this.$store.commit('DEL_ERROR', 'FE020');
        }
        this.$store.commit('SET_SAVEFORLATERGDPR', value);
      },
    },

  },
  methods: {
    ...mapActions({
      tryAgain: 'saveFiles',
      saveForLater: 'saveForLater',
    }),
    tryAgainSaveForLater() {
      if (!this.saveForLaterGDPR) {
        this.$store.commit('SET_ERRORS', [...this.errors, 'FE020']);
      } else {
        this.saveForLater();
      }
    },
  },
  mounted() {
    const { saveStatus, saveType } = this.$route.query;
    if (saveType === 'SAVE' || saveType === 'FORLATER') {
      this.$store.commit('SET_SAVE', { key: 'type', value: saveType });
    }
    if (saveStatus === 'true' || saveStatus === 'false') {
      this.$store.commit('SET_SAVE', { key: 'successful', value: saveStatus === 'true' });
    }
  },
};
</script>

<style scoped>

</style>
